<template>
  <div :class="'background ' + odd">
    <div class="header row">
      <div class="brands">PASSEPORT<br>TRAÇABILITÉ</div>
      <div class="brands"><img src="@/assets/reseau-environnement-blanc.png" class="logo-tracesq"></div>
    </div>
    <div class="content">
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script>

export default {
  name: 'PassportPage',
  props: [
    'odd'
  ]
}
</script>

<style>
.logo-tracesq {
  height: 0.9in;
}
.row {
  display: table;
}
.brands {
  display: table-cell;
  width: 50%;
  text-align: center;
  vertical-align: middle;
}
.header {
  width: 8in;
  font-size: 250%;
  color: #e9d498;
  padding: 15px 0px 6px;
}
.content {
  background-color: #d7e9f4;
  color-adjust: exact;
  -webkit-print-color-adjust: exact;
  margin: 15px 30px 10px 30px;
  padding: 8px 10px 5px 10px;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  height: 3in;
}

.background {
  background-color: #113C6D;
  color-adjust: exact;
  -webkit-print-color-adjust: exact;
  background-image: url(~@/assets/PatternOptel.svg);

  width: 8in;
  height: 4.7in;
  margin-left: auto;
  margin-right: auto;
}

.odd {
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
}

.even {
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
}

.both {
  border-radius: 15px;
}
</style>
